import React, { useState } from "react";

import { t } from "i18next";

import { ArrowUpward } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";

import { SortOrderAtomEnum } from "../../../../state/sortOrderAtom";

import { PrimitiveAtom, useAtom } from "jotai";

export interface SortAuctionsButtonProps {
  sortOrderAtom: PrimitiveAtom<SortOrderAtomEnum>;
}

const SortAuctionsButton = ({ sortOrderAtom }: SortAuctionsButtonProps) => {
  const [sortOrder, setSortOrder] = useAtom(sortOrderAtom);
  const [isButtonDisabled, setButtonDisabled] = useState(false);

  const sortAuction = () => {
    if (!isButtonDisabled) {
      setButtonDisabled(true);
    }

    if (sortOrder === SortOrderAtomEnum.NEW_ADS_FIRST) {
      setSortOrder(SortOrderAtomEnum.OLDEST_FIRST);
    } else {
      setSortOrder(SortOrderAtomEnum.NEW_ADS_FIRST);
    }

    setTimeout(() => {
      setButtonDisabled(false);
    }, 500);
  };

  return (
    <Button
      onClick={sortAuction}
      disabled={isButtonDisabled}
      variant="outlined"
      color="primary"
      sx={{
        "& .MuiButton-startIcon": {
          transform:
            sortOrder === SortOrderAtomEnum.OLDEST_FIRST
              ? "rotate(180deg)"
              : "rotate(0deg)",
          transition: "0.5s"
        },
        width: {
          xs: "100%",
          sm: "auto"
        }
      }}
      startIcon={<ArrowUpward />}
    >
      <Typography
        variant="caption"
        sx={(muiTheme) => ({
          cursor: "pointer !important",

          "@media screen and (min-width: 672px)": {
            width: "100px"
          },

          fontWeight: muiTheme.typography.fontWeightBold
        })}
      >
        {sortOrder === SortOrderAtomEnum.NEW_ADS_FIRST
          ? t("dealer.searchFilters.sortOrderNewestFirst")
          : t("dealer.searchFilters.sortOrderOldestFirst")}
      </Typography>
    </Button>
  );
};

export default SortAuctionsButton;
